/**
 * Constants.ts
 *
 * A module for all UI constants.
 */
/**
 * HTML attribute names
 */
export class AttributeName {}
AttributeName.Alt = "alt";
AttributeName.AriaLabel = "aria-label";
AttributeName.AriaSelected = "aria-selected";
AttributeName.AriaOrientation = "aria-orientation";
AttributeName.AriaExpanded = "aria-expanded";
AttributeName.AriaControls = "aria-controls";
AttributeName.AriaHasPopups = "aria-haspopup";
AttributeName.AriaModal = "aria-modal";
AttributeName.AriaLabelledBy = "aria-labelledby";
AttributeName.AriaDescribedBy = "aria-describedby";
AttributeName.Class = "class";
AttributeName.DataHtml2CanvasIgnore = "data-html2canvas-ignore";
AttributeName.Disabled = "disabled";
AttributeName.Fill = "fill";
AttributeName.For = "for";
AttributeName.Preview = "preview";
AttributeName.Form = "form";
AttributeName.Height = "height";
AttributeName.HRef = "href";
AttributeName.Id = "id";
AttributeName.MaxLength = "maxlength";
AttributeName.Name = "name";
AttributeName.Placeholder = "placeholder";
AttributeName.Points = "points";
AttributeName.Rel = "rel";
AttributeName.Role = "role";
AttributeName.Source = "src";
AttributeName.Stroke = "stroke";
AttributeName.TabIndex = "tabindex";
AttributeName.Target = "target";
AttributeName.Transform = "transform";
AttributeName.Type = "type";
AttributeName.Value = "value";
AttributeName.ViewBox = "viewBox";
AttributeName.Width = "width";
AttributeName.xlinkHref = "xlink:href";
AttributeName.X = "x";
AttributeName.Y = "y";
/**
 * HTML attribute values
 */
export class AttributeValue {}
AttributeValue.BlankWindow = "_blank";
AttributeValue.Button = "button";
AttributeValue.Dialog = "dialog";
AttributeValue.Tab = "tab";
AttributeValue.TabList = "tablist";
AttributeValue.TabPanel = "tabpanel";
AttributeValue.Checkbox = "checkbox";
AttributeValue.Checked = "checked";
AttributeValue.False = "false";
AttributeValue.Zero = "0";
AttributeValue.Polite = "polite";
AttributeValue.Radio = "radio";
AttributeValue.Submit = "submit";
AttributeValue.ScreenshotPreview = "ScreenshotPreview";
AttributeValue.Text = "text";
AttributeValue.TextAreaMaxLength = "1000";
AttributeValue.True = "true";
AttributeValue.Unchecked = "unchecked";
AttributeValue.NoReferrer = "noreferrer";
AttributeValue.AriaOrientationValueVertical = "vertical";
/**
 * URL Parameters
 */
export class UrlParameters {}
UrlParameters.CLCID = "CLCID";
/**
 * CSS classes
 */
export class Classes {}
Classes.AriaLiveTemplate = "obf-AriaLiveTemplate";
Classes.CheckBox = "obf-CheckBox";
Classes.FontTitle = "obf-FontTitle";
Classes.CloseButton = "obf-CloseButton";
Classes.FontSubtitle = "obf-FontSubtitle";
Classes.FontText = "obf-FontText";
Classes.FontSubText = "obf-FontSubText";
Classes.FontSubSubText = "obf-FontSubSubText";
Classes.Hidden = "obf-Hidden";
Classes.Link = "obf-Link";
Classes.MarginLeft60px = "obf-MarginLeft60px";
Classes.MarginLeft180px = "obf-MarginLeft180px";
Classes.NarrowLayout = "obf-NarrowLayout";
Classes.PrivacyStatementLinkDiv = "obf-PrivacyStatementLinkDiv";
Classes.Rtl = "obf-Rtl";
Classes.Spinner = "obf-Spinner";
Classes.SpinnerCircle = "obf-SpinnerCircle";
Classes.SubmitButton = "obf-SubmitButton";
Classes.CancelButton = "obf-CancelButton";
Classes.TextInput = "obf-TextInput";
Classes.Visible = "obf-Visible";
// rating control
Classes.Rating = "obf-Rating";
Classes.RatingGraphic = "obf-RatingGraphic";
Classes.RatingGraphicFilled = "obf-RatingGraphic-Filled";
// choice group control
Classes.ChoiceGroup = "obf-ChoiceGroup";
Classes.ChoiceGroupIcon = "obf-ChoiceGroupIcon";
// region BellyBand
Classes.OverallAnchor = "obf-OverallAnchor";
Classes.OverallAnchorActive = "obf-OverallAnchorActive";
Classes.OverallImage = "obf-OverallImage";
Classes.OverallText = "obf-OverallText";
Classes.SingleLayout = "obf-SingleLayout";
Classes.ShowRightBorder = "obf-ShowRightBorder";
Classes.SlideLeft = "obf-slideLeft";
Classes.TextAlignLeft = "obf-TextAlignLeft";
Classes.FormContainer = "obf-FormContainer";
Classes.FormWideContainer = "obf-FormWideContainer";
// region ThanksPanel
Classes.ThanksPanelTitle = "obf-ThanksPanelTitle";
Classes.ThanksPanelMessage = "obf-ThanksPanelMessage";
// form classes
Classes.FormQuestionMiddleText = "obf-FormQuestionMiddleText";
Classes.FormMiddleText = "obf-FormMiddleText";
Classes.FormCategoriesDropdown = "obf-FormCategoriesDropdown";
Classes.FormComment = "obf-FormComment";
Classes.FormRatingContainer = "obf-FormRatingContainer";
Classes.FormRatingLabel = "obf-FormRatingLabel";
Classes.FormRating = "obf-FormRating";
Classes.FormEmailContainer = "obf-FormEmailContainer";
Classes.FormEmailInput = "obf-FormEmailInput";
Classes.FormEmailTextBox = "obf-FormEmailTextBox";
Classes.FormEmailCheckBox = "obf-FormEmailCheckBox";
Classes.FormEmailLabel = "obf-FormEmailLabel";
Classes.FormBottomContainer = "obf-FormBottomContainer";
Classes.FormSubmitButtonContainer = "obf-FormSubmitButtonContainer";
Classes.FormScreenshotContainer = "obf-FormScreenshotContainer";
Classes.FormScreenshotLabel = "obf-FormScreenshotLabel";
Classes.FormScreenshotCheckbox = "obf-FormScreenshotCheckbox";
Classes.FormScreenshotPreview = "obf-FormScreenshotPreview";
// email textbox classes
Classes.TFormEmailCheckbox = "obf-TFormEmailCheckbox";
Classes.TFormEmailLabel = "obf-TFormEmailLabel ";
// email checkbox classes
Classes.EmailCheckBoxLabel = "obf-EmailCheckBoxLabel";
// endregion
// region Toast
Classes.Toast = "obf-Toast";
Classes.ToastZoom = "obf-ToastZoom";
/**
 * HTML element ids
 */
export class IDs {}
// region BellyBand
IDs.CloseButton = "obf-CloseButton";
IDs.ColumnSeparatorDiv = "obf-ColumnSeparatorDiv";
IDs.OverallAnchorsContainer = "obf-OverallAnchorsContainer";
IDs.OverallFrownAnchor = "obf-OverallFrownAnchor";
IDs.OverallFrownDiv = "obf-OverallFrownDiv";
IDs.OverallFrownImage = "obf-OverallFrownImage";
IDs.OverallFrownText = "obf-OverallFrownText";
IDs.OverallSmileAnchor = "obf-OverallSmileAnchor";
IDs.OverallSmileDiv = "obf-OverallSmileDiv";
IDs.OverallSmileImage = "obf-OverallSmileImage";
IDs.OverallSmileText = "obf-OverallSmileText";
IDs.OverallIdeaAnchor = "obf-OverallIdeaAnchor";
IDs.OverallIdeaDiv = "obf-OverallIdeaDiv";
IDs.OverallIdeaImage = "obf-OverallIdeaImage";
IDs.OverallIdeaText = "obf-OverallIdeaText";
IDs.OverallBugAnchor = "obf-OverallBugAnchor";
IDs.OverallBugDiv = "obf-OverallBugDiv";
IDs.OverallBugImage = "obf-OverallBugImage";
IDs.OverallBugText = "obf-OverallBugText";
IDs.QuestionLeftText = "obf-QuestionLeftText";
IDs.LeftFormContainer = "obf-LeftFormContainer";
IDs.LeftPanelContainer = "obf-LeftPanelContainer";
IDs.MainContainer = "obf-MainContainer";
IDs.MainContentHolder = "obf-MainContentHolder";
IDs.MiddleFormContainer = "obf-MiddleFormContainer";
IDs.OverlayBackground = "obf-OverlayBackground";
IDs.PrivacyStatementLink = "obf-PrivacyStatementLink";
IDs.FirstTabbable = "obf-FirstTabbable";
IDs.LastTabbable = "obf-LastTabbable";
IDs.EmailCheckBox = "obf-EmailCheckBox";
// Single form ids
IDs.SingleFormContainer = "obf-SingleFormContainer";
IDs.SingleFormQuestionMiddleText = "obf-SingleFormQuestionMiddleText";
IDs.SingleFormCategoriesDropdown = "obf-SingleFormCategoriesDropdown";
IDs.SingleFormComment = "obf-SingleFormComment";
IDs.SingleFormEmailInput = "obf-SingleFormEmailInput";
IDs.SingleFormRating = "obf-SingleFormRating";
IDs.SingleFormScreenshotCheckbox = "obf-SingleFormScreenshotCheckbox";
IDs.SingleFormScreenshotPreview = "obf-SingleFormScreenshotPreview";
IDs.SingleFormSubmitButton = "obf-SingleFormSubmitButton";
IDs.SingleFormCancelButton = "obf-SingleFormCancelButton";
IDs.SingleFormSubmitButtonSpinner = "obf-SingleFormSubmitButtonSpinner";
// Basic form ids
IDs.BasicFormContainer = "obf-BasicFormContainer";
IDs.BasicFormQuestionMiddleText = "obf-BasicFormQuestionMiddleText";
IDs.BasicFormCategoriesDropdown = "obf-BasicFormCategoriesDropdown";
IDs.BasicFormComment = "obf-BasicFormComment";
IDs.BasicFormEmailInput = "obf-BasicFormEmailInput";
IDs.BasicFormRating = "obf-BasicFormRating";
IDs.BasicFormScreenshotCheckbox = "obf-BasicFormScreenshotCheckbox";
IDs.BasicFormScreenshotPreview = "obf-BasicFormScreenshotPreview";
IDs.BasicFormSubmitButton = "obf-BasicFormSubmitButton";
IDs.BasicFormCancelButton = "obf-BasicFormCancelButton";
IDs.BasicFormSubmitButtonSpinner = "obf-BasicFormSubmitButtonSpinner";
// Thanks Panel ids
IDs.ThanksPanelContainer = "obf-ThanksPanelContainer";
IDs.ThanksPanelCloseButton = "obf-ThanksPanelCloseButton";
IDs.ThanksPanelDiscussion = "obf-ThanksPanelDiscussion";
IDs.ThanksPanelVerticalContainer = "obf-ThanksPanelVerticalContainer";
IDs.ThanksPanelInnerContainer = "obf-ThanksPanelInnerContainer";
// UserVoice form ids
IDs.UserVoiceFormContainer = "obf-UserVoiceFormContainer";
IDs.UserVoiceFormGoButton = "obf-UserVoiceFormGoButton";
// endregion
// region Toast
IDs.ToastContainer = "obf-ToastContainer";
IDs.ToastCancel = "obf-ToastCancel";
// Prompt ids
IDs.TPromptContainer = "obf-TPromptContainer";
IDs.TPromptTitle = "obf-TPromptTitle";
IDs.TPromptText = "obf-TPromptText";
// Survey ids
IDs.TFormContainer = "obf-TFormContainer";
IDs.TFormTitle = "obf-TFormTitle";
IDs.TFormRating = "obf-TFormRating";
IDs.TFormRatingQuestion = "obf-TFormRatingQuestion";
IDs.TFormComment = "obf-TFormComment";
IDs.TFormEmailTextBox = "obf-TFormEmailTextBox";
IDs.TFormEmailCheckBox = "obf-TFormEmailCheckBox";
IDs.TFormEmailLabel = "obf-TFormEmailLabel";
IDs.TFormSubmitButton = "obf-TFormSubmitButton";
IDs.TFormSubmitButtonSpinner = "obf-TFormSubmitButtonSpinner";
IDs.TFormSubmitButtonContainer = "obf-TFormSubmitButtonContainer";
/**
 * Keys
 */
export class Keys {}
Keys.Esc = 27;
Keys.Tab = 9;
/**
 * HTML tags
 */
export class Tags {}
Tags.Anchor = "A";
Tags.Button = "button";
Tags.Defs = "defs";
Tags.Div = "div";
Tags.FieldSet = "fieldset";
Tags.Form = "form";
Tags.Img = "img";
Tags.Input = "input";
Tags.Label = "label";
Tags.Legend = "legend";
Tags.Option = "option";
Tags.Polygon = "polygon";
Tags.Select = "select";
Tags.Span = "span";
Tags.Svg = "svg";
Tags.TextArea = "textarea";
Tags.Use = "use";
/**
 * HTML roles
 */
export class Roles {}
Roles.Button = "Button";
/**
 * URLs
 */
export class Urls {}
/**
 * Link to the feedback Privacy Statement
 */
Urls.PrivacyStatementLink = "https://go.microsoft.com/fwlink/?LinkId=521839";